module.exports = __webpack_public_path__ + "img/new-treatment-modal-mobile-en.cbb4c22d.jpg";